module.exports = __webpack_public_path__ + "static/img/08-lampe.5eb63f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/08-lampe.jpg
// module id = 115
// module chunks = 0